import Environment from "../environment";

import Api from "./ApiService";
import { AuthService } from "./AuthService";

import Unidad from "../models/Unidad";
import Consumo from "../models/Consumo";

export const UnidadService = {
    unidades: params => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem("currentUser"));
            return Api.fetch(
                `${Environment.api}api/usuarios/${user["id"]}/unidades-facturaciones`,
                "GET",
                params
            )
                .then(data => {
                    resolve(data.map(i => new Unidad(i)));
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    unidad: id => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem("currentUser"));
            return Api.fetch(
                `${Environment.api}api/usuarios/${user["id"]}/unidades-facturaciones/${id}`,
                "GET"
            )
                .then(data => {
                    resolve(new Unidad(data));
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    vincular: data => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem("currentUser"));
            return Api.fetch(
                `${Environment.api}api/usuarios/${user["id"]}/unidades-facturaciones`,
                "POST",
                data
            )
                .then(data => {
                    resolve(new Unidad(data));
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    desvincular: id => {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem("currentUser"));
            return Api.fetch(
                `${Environment.api}api/usuarios/${user["id"]}/unidades-facturaciones/${id}`,
                "DELETE",
                {}
            )
                .then(data => {
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    confirmarDesvincular: data => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades/confirmar_desvincular`,
                "POST",
                data
            )
                .then(data => {
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    consumos: id => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${id}/consumos`,
                "GET"
            )
                .then(data => {
                    resolve(data.map(i => new Consumo(i)));
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    estadoDebito: id => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${id}/estado-debito`,
                "GET"
            )
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    altaDebito: (data, id) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${id}/alta-debito`,
                "POST",
                data
            )
                .then(data => {
                    resolve("finish"); //@todo ver que devolver
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    bajaDebito: (data, id) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${id}/baja-debito`,
                "PUT",
                data
            )
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    ultimaFactura: id => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${id}/ultima-factura`,
                "GET"
            )
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};
